/**
 * Available locale codes for the component library
 */
export const LOCALE_CODES = {
    ENGLISH: 'en',
    FRENCH: 'fr',
};
/**
 * Array of all available locale codes
 */
export const AVAILABLE_LOCALES = [
    LOCALE_CODES.ENGLISH,
    LOCALE_CODES.FRENCH,
];
/**
 * Default locale for the application
 */
export const DEFAULT_LOCALE = LOCALE_CODES.ENGLISH;
//# sourceMappingURL=locale-codes.js.map